'use client';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
// import Button from "@mui/material/Button";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import * as _ from 'lodash';
import Cookies from 'js-cookie';
import {
  MagnifyingGlassIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowsUpDownIcon,
  ArrowTopRightOnSquareIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DeleteIcon,
} from '@heroicons/react/24/outline';
import mqtt from 'mqtt';
import { useUserContext } from '../contexts/UserContext';
import { set } from 'date-fns';

let signalstopic = 'goldensparrowcapital-signals';

const MeanTheoryComponent = props => {
  const {
    user
  } = useUserContext();
  const [meanTheoryData, setMeanTheoryData] = useState([]);
  // Store current prices by symbol for efficient updates

  const [client, setClient] = useState(null);
  const mqttClientRef = useRef(null); // holds the MQTT client instance
  const mqttListenerAttached = useRef(false); // ensures only one message handler is attached
  const wsRefBinance = useRef(null);
  const [lastUpdated, setLastUpdated] = useState(new Date().valueOf());
  const [popupMeanTheory, setPopupMeanTheory] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false)

  //connect and subscribe to MQTT broker
  const _connectMQTT = useCallback(async (props) => {
    if (mqttClientRef.current) return; // already connected
    let clientID = 'GoldenSparrowCapital-' + user.user_uuid;
    const gsccookie = Cookies.get('gsccookie') || null;
    const newClient = mqtt.connect(process.env.REACT_APP_EXTERNAL_MQTT_SERVER_URL, {
      clientId: clientID,
      username: 'user-jwt',
      password: gsccookie,
      clean: true,
      rejectUnauthorized: true,
      reconnectPeriod: 60000,
    });
    mqttClientRef.current = newClient;
    setClient(newClient);

    //why is this disconnecting from mqtt server every 1-2 minutes
    newClient.on('error', (err) => {
      console.error('MQTT Client Error:', err);
    });

    newClient.on('connect', async () => {
      console.log('Connected to MQTT:', new Date().toLocaleTimeString());

      newClient.publish('GET_MEAN_THEORY_DATA', JSON.stringify({ token: gsccookie }), err => {
        if (!err) {
          console.log('GET_MEAN_THEORY_DATA request published:', new Date().toLocaleTimeString());
        } else {
          console.error('Topic Publish error', err);
        }
      });

      newClient.unsubscribe('RECEIVE_MEAN_THEORY_DATA_WEB');

      newClient.subscribe('RECEIVE_MEAN_THEORY_DATA_WEB', err => {
        if (!err) {
          // console.log('Topic subscribed:RECEIVE_MEAN_THEORY');
        } else {
          console.error('Topic Subscribe error', err);
        }
      });

      newClient.on('message', (topic, message) => {
        console.log('Received topic:', topic, new Date().toLocaleTimeString());
        if (topic == 'RECEIVE_MEAN_THEORY_DATA_WEB') {
          let raw = JSON.parse(message);
          let data = raw.meanTheoryData
          const groupedData = data.reduce((acc, item) => {
            (acc[item.symbol] = acc[item.symbol] || []).push(item);
            return acc;
          }, {});
          const finalResult = Object.keys(groupedData).map(symbol => ({
            symbol,
            data: groupedData[symbol],
            maxCreationDate: Math.max(...groupedData[symbol].map(item => item.creationDate))
          }));
          // console.log(finalResult);
          setMeanTheoryData(finalResult);
          setLastUpdated(new Date().valueOf());

        }

      });
    });

  }, [setClient, setIsProcessing]);


  useEffect(() => {
    async function fetchData() {
      if (user.userType == "ADMIN") {
        await _connectMQTT(props);
      }
    }
    fetchData();
  }, []);

  // async function handleDelete(uuid) {
  //   // console.log("Deleting PreWatcher:", uuid)
  //   //remove preWatcher from preWatchers state
  //   // setPreWatchers(prevPreWatchers => prevPreWatchers.filter(preWatcher => preWatcher.uuid !== uuid));

  //   const gsccookie = Cookies.get('gsccookie') || null;
  //   console.log("Deleting PreWatcher:", uuid, gsccookie)

  //   client.publish("DELETE_PREWATCHER", JSON.stringify({ token: gsccookie, uuid }), err => {

  //   });
  // }



  // Memoize preWatchers with current prices for rendering

  return meanTheoryData ? (
    <div style={{ borderRadius: 8, width: 'auto' }}>
      {/* <PreWatcherPopup
        preWatcher={popupPreWatcher}
        onClose={() => {
          setPopupPreWatcher(null);
        }}
         transitionPreWatcherToWatcher={object => {

          const gsccookie = Cookies.get('gsccookie') || null;
          client.publish('TRANSITION_PREWATCHER_TO_WATCHER', JSON.stringify({ token: gsccookie, preWatcher: object.preWatcher, limitPrice: object.limitPrice, stopLossPrice: object.stopLossPrice, currentPrice: object.symbolCurrentPrice }), err => {
            if (!err) {
              setPopupPreWatcher(null);
            } else {
              console.error('TRANSITION_PREWATCHER_TO_WATCHER Error:', err);
              alert("Error: Transitioning to Watcher")
            }
          });
        }}
      /> */}
      {/* <h6 style={{ margin: 3, textAlign : "right", fontSize : 12 }}>Count: {watchers.length}</h6> */}
      {/* <h1 className="text-sm font-normal">{props.user.email + ',' + props.user.userType}</h1> */}
      <h1 className="text-xs" style={{ margin: 0, paddingTop: 1, color: 'gray', marginBottom: 3 }}>
        Last Updated: {new Date(lastUpdated).toLocaleDateString()} ,{' '}
        {new Date(lastUpdated).toLocaleTimeString()}
      </h1>
      

      <h1 className="text-sm" style={{ margin: 0, paddingTop: 1, color: '#fff', marginBottom: 3 }}>
        Count: {meanTheoryData.length}
      </h1>

      <table>
        {/* <thead>
          <tr>
            <th>Symbol</th>
         
          </tr>
        </thead> */}
        <tbody>
          {meanTheoryData.sort((a, b) => b.maxCreationDate - a.maxCreationDate).map((item,index) => (

            <div key={item.symbol} className="bg-white dark:bg-gray-600" style={{ padding: 5, margin: 5, borderRadius: 10 }}>
              <table>
                <tbody>
               
            <div style={{ display: 'flex',width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>

              {/*both the following buttons should horizontally appear in same line*/}
              <button
                style={{
                  backgroundColor: '#0474c9',
                  fontSize: 12,
                  borderRadius: 5,
                  padding: 3,
                }}
                onClick={() => {
                  window.open(
                    'https://www.coinglass.com/tv/Binance_' + item.symbol,
                        '_blank'
                      )

                    }}
                  >
                    <div style={{ alignItems: 'center', display: 'flex' }}>
                      <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>{index+1}. {item.symbol}</h4>
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 3 }}
                      >
                        {/* Dark background circle matching trading terminal themes */}
                        <circle cx="16" cy="16" r="16" fill="#1E222D" />

                        {/* Upward diagonal arrow symbolizing market breakouts and data shifts */}
                        <path
                          d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                          stroke="#ffffff"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />

                        {/* Subtle outer border for depth */}
                        <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                      </svg>
                    </div>
                  </button>
                  {/* The below button should be on the extreme right of the table row and should have a red background with a white cross icon in the center */}
                
                <button
                    style={{
                      background: 'red',
                      border: 'none',
                      borderRadius: 5,
                      color: '#fff',
                      cursor: 'pointer',
                      marginLeft: 'auto',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 20,
                      height: 20,
                      padding: 0,
                    }}
                    title="Delete"
                    onClick={() => {
                      // Implement your delete logic here, e.g. call a delete handler with item.symbol
                      // Example: handleDelete(item.symbol)
                      alert(`Delete ${item.symbol}`);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      fill="none"
                      viewBox="0 0 14 14"
                      stroke="white"
                      style={{ display: 'block' }}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 3l8 8M11 3l-8 8" />
                    </svg>
                  </button>
                </div>



                  {item.data.sort((a, b) => b.creationDate - a.creationDate).map((dataItem, index) => (
                    <tr key={dataItem.uuid} style={{marginTop : 2, color : dataItem?.candleColor == "GREEN" ? "green" : "red"}}>
                      <td style={{fontSize : 13}}>{dataItem.strategyName}</td>
                      <td style={{fontSize : 13, marginLeft: 15}}>{"->"}{dataItem.timeFrame}</td>
                       <td style={{fontSize : 13, marginLeft: 15}}>{"->"}{dataItem?.lowestPrice}</td>
                        <td style={{fontSize : 13, marginLeft: 15}}>{"->"}{dataItem?.lowerWickPercentage}</td>
                      <td style={{fontSize : 13, marginLeft: 15}}>{"->"}{new Date(dataItem.creationDate).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          ))}
        </tbody>
      </table>

    </div>
  ) : null;
};

// function PreWatcherPopup({ preWatcher, onClose, transitionPreWatcherToWatcher }) {
//   const wsRefBinance = useRef(null);
//   const [limitPrice, setLimitPrice] = useState(null)
//   const [stopLossPrice, setStopLossPrice] = useState(null)
//   const [symbolCurrentPrice, setSymbolCurrentPrice] = useState(null)
//   useEffect(() => {
//     if (preWatcher && preWatcher.currentPrice) {
//       setLimitPrice(Number(preWatcher.currentPrice).toFixed(preWatcher.numberOfDecimalValues));
//       setStopLossPrice(Number(preWatcher.lowestPrice).toFixed(preWatcher.numberOfDecimalValues));
//       subscribeToSymbols([preWatcher.symbol]);
//     }
//   }, [preWatcher]);

//   // Function to subscribe to real-time Binance prices
//   const subscribeToSymbols = async (symbols) => {
//     console.log("Subscribing to Binance prices for:", symbols.length);
//     unsubscribeFromSymbols();
//     const streams = symbols.map(symbol => `${symbol.toLowerCase()}@ticker`).join('/');
//     const url = `wss://stream.binance.com:9443/stream?streams=${streams}`;

//     wsRefBinance.current = new WebSocket(url);

//     wsRefBinance.current.onmessage = event => {
//       const message = JSON.parse(event.data);
//       const { s: symbol, c: currentPrice } = message.data;
//       //  console.log(`Real-time price update for ${symbol}: ${currentPrice}`);
//       setSymbolCurrentPrice(currentPrice)
//     };

//     wsRefBinance.current.onerror = err => {
//       // console.error("Binance WebSocket error:", err);
//     };

//     wsRefBinance.current.onclose = () => {
//       // console.log("Binance WebSocket closed");
//     };
//   };

//   // Function to unsubscribe/cleanup
//   const unsubscribeFromSymbols = () => {
//     if (wsRefBinance.current) {
//       wsRefBinance.current.close();
//       wsRefBinance.current = null;
//       // console.log('Unsubscribed from Binance prices');
//     }
//   };

//   if (!preWatcher) return null;
//   return (
//     <div
//       style={{
//         position: 'fixed',
//         top: '50%',
//         left: '50%',
//         transform: 'translate(-50%, -50%)',
//         zIndex: 9999,
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'stretch',
//       }}
//       onClick={onClose}
//     >
//       <div
//         id="preWatcher-popoup"
//         style={{
//           width: '450px',
//           backgroundColor: '#fff',
//           padding: 24,
//           borderRadius: 16,
//           display: 'flex',
//           flexDirection: 'column',
//           overflowY: 'auto',
//           paddingRight: 10,
//         }}
//         onClick={e => e.stopPropagation()}
//       >

//         {/* 1st row */}
//         <div
//           style={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             marginBottom: 8,
//           }}
//         >
//           <h1 style={{ color: "blue", fontWeight: "bold" }}>{preWatcher.symbol}
//             ({Number(symbolCurrentPrice).toFixed(preWatcher.numberOfDecimalValues)})
//           </h1>
//           <button
//             style={{
//               padding: '4px',
//               borderWidth: 1,
//               borderColor: "red",
//               color: 'red',
//               borderRadius: 6,
//               fontSize: 11,
//               cursor: 'pointer',
//             }}
//             onClick={() => {
//               unsubscribeFromSymbols()
//               onClose()
//             }}
//           >
//             Close
//           </button>
//         </div>
//         <hr></hr>

//         {symbolCurrentPrice ?
//           <>
//             {/* 2nd Row */}
//             <div
//               style={{
//                 display: 'flex',
//                 // justifyContent: 'space-between',
//                 alignItems: 'center',
//                 marginBottom: 8,
//                 marginTop: 30,
//                 gap: 20
//               }}
//             >
//               <h1 style={{ color: '#282828', fontWeight: "bold", fontStyle: "italic", fontSize: 13 }}>Set Limit Price:</h1>
//               <button
//                 style={{
//                   padding: 3,
//                   backgroundColor: 'red',
//                   color: '#fff',
//                   borderRadius: 50,
//                   fontSize: 18,
//                   cursor: 'pointer',
//                   width: 35,
//                   height: 35
//                 }}
//                 onClick={() => {

//                   let ll = limitPrice
//                   setLimitPrice(Number(Number(ll).toFixed(preWatcher.numberOfDecimalValues) - (1 / Math.pow(10, preWatcher.numberOfDecimalValues))).toFixed(preWatcher.numberOfDecimalValues))

//                   let sl = stopLossPrice
//                   if (Number(sl) >= Number(limitPrice)) {
//                     setStopLossPrice(Number(Number(ll).toFixed(preWatcher.numberOfDecimalValues) - (2 / Math.pow(10, preWatcher.numberOfDecimalValues))).toFixed(preWatcher.numberOfDecimalValues))
//                   }

//                 }}
//               >
//                 -
//               </button>
//               <h1 style={{ color: '#282828', fontWeight: 'bold' }}>{limitPrice}</h1>

//               <button
//                 style={{
//                   padding: 3,
//                   backgroundColor: 'green',
//                   color: '#fff',
//                   borderRadius: 50,
//                   fontSize: 18,
//                   cursor: 'pointer',
//                   width: 35,
//                   height: 35

//                 }}
//                 onClick={() => {

//                   let ll = limitPrice
//                   setLimitPrice(Number(Number(ll).toFixed(preWatcher.numberOfDecimalValues) + (1 / Math.pow(10, preWatcher.numberOfDecimalValues))).toFixed(preWatcher.numberOfDecimalValues))
//                 }}
//               >
//                 +
//               </button>





//             </div>

//             {/* 3rd Row */}
//             <div
//               style={{
//                 display: 'flex',
//                 // justifyContent: 'space-between',
//                 alignItems: 'center',
//                 marginBottom: 8,
//                 marginTop: 30,
//                 gap: 20
//               }}
//             >
//               <h1 style={{ color: '#282828', fontWeight: "bold", fontStyle: "italic", fontSize: 13 }}>Set Stop Loss Price:</h1>
//               <button
//                 style={{
//                   padding: 3,
//                   backgroundColor: 'red',
//                   color: '#fff',
//                   borderRadius: 50,
//                   fontSize: 18,
//                   cursor: 'pointer',
//                   width: 35,
//                   height: 35
//                 }}
//                 onClick={() => {
//                   let ll = stopLossPrice
//                   setStopLossPrice(Number(Number(ll).toFixed(preWatcher.numberOfDecimalValues) - (1 / Math.pow(10, preWatcher.numberOfDecimalValues))).toFixed(preWatcher.numberOfDecimalValues))
//                 }}
//               >
//                 -
//               </button>
//               <h1 style={{ color: '#282828', fontWeight: 'bold' }}>{stopLossPrice}</h1>

//               <button
//                 style={{
//                   padding: 3,
//                   backgroundColor: 'green',
//                   color: '#fff',
//                   borderRadius: 50,
//                   fontSize: 18,
//                   cursor: 'pointer',
//                   width: 35,
//                   height: 35

//                 }}
//                 onClick={() => {
//                   let ll = stopLossPrice
//                   setStopLossPrice(Number(Number(ll).toFixed(preWatcher.numberOfDecimalValues) + (1 / Math.pow(10, preWatcher.numberOfDecimalValues))).toFixed(preWatcher.numberOfDecimalValues))
//                 }}
//               >
//                 +
//               </button>
//             </div>

//             {/* 4th row */}
//             <div
//               style={{
//                 display: 'flex',
//                 marginBottom: 8,
//                 justifyContent: "center",
//                 columnGap: 5
//               }}
//             >
//               <button
//                 style={{
//                   padding: '5px',
//                   borderWidth: 1,
//                   borderColor: "blue",
//                   color: 'blue',
//                   borderRadius: 6,

//                   cursor: 'pointer',
//                   marginTop: 30,
//                   fontSize: 14,


//                 }}
//                 onClick={() => {
//                   transitionPreWatcherToWatcher({ preWatcher, limitPrice, stopLossPrice, symbolCurrentPrice })
//                 }}
//               >
//                 Add to Watcher
//               </button>


//             </div>
//           </>
//           : null}
//       </div>
//     </div>
//   );
// }

export default MeanTheoryComponent;
